const breadcrumbsHome = { name: 'Home', pathName: '/' }

export default [
  {
    path: '/external-bi/clients-base',
    component: () => import('@/modules/external_bi/ClientsBasePBI.vue'),
    meta: {
      title: 'BI - Base de clientes',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/commercial',
    component: () => import('@/modules/external_bi/CommercialPBI.vue'),
    meta: {
      title: 'BI - Comercial',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/commercial-2023',
    component: () => import('@/modules/external_bi/Commercial2023PBI.vue'),
    meta: {
      title: 'BI - Comercial - 2023',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/engineering-jira',
    component: () => import('@/modules/external_bi/EngineeringJIRAPBI.vue'),
    meta: {
      title: 'BI - Eng - JIRA',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/retailer-app',
    component: () => import('@/modules/external_bi/RetailerAppPBI.vue'),
    meta: {
      title: 'BI - Varejista - App',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/marketing',
    component: () => import('@/modules/external_bi/MarketingPBI.vue'),
    meta: {
      title: 'BI - Marketing',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/partnerships',
    component: () => import('@/modules/external_bi/CommercialPartnershipsPBI.vue'),
    meta: {
      title: 'Parcerias',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/partnerships-referrals',
    component: () => import('@/modules/external_bi/CommercialPartnershipsReferralsPBI.vue'),
    meta: {
      title: 'Parcerias - Indicantes',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/dash-ops',
    component: () => import('@/modules/external_bi/DashOpsPBI.vue'),
    meta: {
      title: 'Dash OPS',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/erp-integrations',
    component: () => import('@/modules/external_bi/ERPIntegrationsPBI.vue'),
    meta: {
      title: 'ERPs',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/support-tickets',
    component: () => import('@/modules/external_bi/SupportTicketsPBI.vue'),
    meta: {
      title: 'Tickets de Suporte',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/bi-tickets',
    component: () => import('@/modules/external_bi/BITicketsPBI.vue'),
    meta: {
      title: 'Tickets de BI',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/ti-deployment',
    component: () => import('@/modules/external_bi/TIDeploymentPBI.vue'),
    meta: {
      title: 'Implantação TI (Antigo)',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/platform-access',
    component: () => import('@/modules/external_bi/PlatformAccessPBI.vue'),
    meta: {
      title: 'Acessos na Plataforma',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/product-catalog',
    component: () => import('@/modules/external_bi/ProductCatalogPBI.vue'),
    meta: {
      title: 'Catálogo de Produtos',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/dags-monitor',
    component: () => import('@/modules/external_bi/DAGsMonitorPBI.vue'),
    meta: {
      title: 'Monitoramento de DAGs',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/ebr-kpis',
    component: () => import('@/modules/external_bi/EBRKPIsPBI.vue'),
    meta: {
      title: 'KPIs para EBR',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/cs-trade-engagement',
    component: () => import('@/modules/external_bi/CSTradeEngagementLooker.vue'),
    meta: {
      title: 'Engajamento de Trade por analista',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/trade-engagement',
    component: () => import('@/modules/external_bi/IndustryEngagementPBI.vue'),
    meta: {
      title: 'Engajamento de Trade',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/trade-offers-errors',
    component: () => import('@/modules/external_bi/TradeOffersErrorsPBI.vue'),
    meta: {
      title: 'Erros de Ofertas de Trade',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/base-expansion',
    component: () => import('@/modules/external_bi/IndustryBaseExpansionPBI.vue'),
    meta: {
      title: 'Expansão de Base',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/promotrade-optin',
    component: () => import('@/modules/external_bi/IndustryPromotradeOptinLooker.vue'),
    meta: {
      title: 'Pitch Opt-in Promotrade',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/multi-industry-analytics',
    component: () => import('@/modules/external_bi/MultiIndustryPBI.vue'),
    meta: {
      title: 'Analytics Multi-indústria',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/okr-2025',
    component: () => import('@/modules/external_bi/OKR2025PBI.vue'),
    meta: {
      title: 'OKR 2025',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/dash-deployment-2',
    component: () => import('@/modules/external_bi/DashDeployment2PBI.vue'),
    meta: {
      title: 'Dash Implantação 2.0',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/finance-revenue',
    component: () => import('@/modules/external_bi/FinanceRevenuePBI.vue'),
    meta: {
      title: 'Faturamento Mercafacil',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/eligible-clients',
    component: () => import('@/modules/external_bi/EligibleClientsPBI.vue'),
    meta: {
      title: 'Aptos a Trade',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/cbm-campaigns',
    component: () => import('@/modules/external_bi/CBMCampaignsPBI.vue'),
    meta: {
      title: 'Campanhas CBM',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/healthscore-mercapromo',
    component: () => import('@/modules/external_bi/HealthscoreMercapromoPBI.vue'),
    meta: {
      title: 'Healthscore Mercapromo',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/mercapromo-implantacao',
    component: () => import('@/modules/external_bi/MercapromoImplantacaoPBI.vue'),
    meta: {
      title: 'Implantação Mercapromo',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/gmv-cpf',
    component: () => import('@/modules/external_bi/GMVCPFPBI.vue'),
    meta: {
      title: 'GMV e CPF',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/wallet-coverage',
    component: () => import('@/modules/external_bi/WalletCoveragePBI.vue'),
    meta: {
      title: 'Cobertura de Carteira',
      breadcrumbs: [breadcrumbsHome]
    }
  },
  {
    path: '/external-bi/dash-support-n2',
    component: () => import('@/modules/external_bi/DashSupportN2PBI.vue'),
    meta: {
      title: 'Dash Suporte N2',
      breadcrumbs: [breadcrumbsHome]
    }
  }
]
